import { render, staticRenderFns } from "./translate-view.vue?vue&type=template&id=2fa30376"
import script from "./translate-view.vue?vue&type=script&lang=js"
export * from "./translate-view.vue?vue&type=script&lang=js"
import style0 from "./translate-view.vue?vue&type=style&index=0&id=2fa30376&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa30376')) {
      api.createRecord('2fa30376', component.options)
    } else {
      api.reload('2fa30376', component.options)
    }
    module.hot.accept("./translate-view.vue?vue&type=template&id=2fa30376", function () {
      api.rerender('2fa30376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/translate-view/translate-view.vue"
export default component.exports